export default () => {
  const w = typeof window !== 'undefined' ? window : global;
  return w.logger;
};